export default class Resources {

	//Themes
	public static readonly body: string = "body";
	public static readonly theme: string = "theme";
	public static readonly default: string = "default";
	public static readonly light: string = "light";
	public static readonly dark: string = "dark";
	public static readonly contrast: string = "contrast";

	//KeyCodes
	public static readonly keyCodeEnter: number = 13;
	public static readonly keyCodeSpace: number = 32;
}